<template>
  <div class="flex center flex-row items-center justify-between w-100 mw5 mw6-ns">
    <div class="social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow">
      <a class="flex flex-row items-center justify-center pointer social-btn facebook" title="Facebook link" href="https://www.facebook.com/themobrep/" target="_blank">
        <simple-svg 
          :filepath="'/assets/images/svg/icons/facebook.svg'"
          :id="'social-icon-svg'"
        ></simple-svg>
      </a>
    </div>
    <div class="social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow">
      <a class="flex flex-row items-center justify-center pointer social-btn instagram" title="Instagram link" href="https://www.instagram.com/themobrep/" target="_blank">
        <simple-svg 
          :filepath="'/assets/images/svg/icons/instagram.svg'"
          :id="'social-icon-svg'"
        ></simple-svg>            
      </a>
    </div>
    <div class="social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow">
      <a class="flex flex-row items-center justify-center pointer social-btn twitter" title="Twitter link" href="https://twitter.com/MobRep_Chi" target="_blank">
        <simple-svg 
          :filepath="'/assets/images/svg/icons/twitter.svg'"
          :id="'social-icon-svg'"
        ></simple-svg>            
      </a> 
    </div>
    <!--
    <div class="social-btn-bg mh0 mh3-ns bg-center flex flex-column items-center justify-center tc grow">
      <a class="flex flex-row items-center justify-center bg-center pointer social-btn youtube" title="Youtube link" href="https://www.facebook.com/themobrep/" target="_blank">
        <simple-svg 
          :filepath="'/assets/images/svg/icons/youtube.svg'"
          :id="'social-icon-svg'"
        ></simple-svg>            
      </a>                                  
    </div>
    -->
  </div>
</template>
<script>
export default {
  //template: '#home-page',
  data () {
    return {
        msg: 'Hello World'
    }
  }
}
</script>